import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1900Component } from './kymw1900.component';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { FileDownloadService } from '../../../commons/kymw02/file-download-confirm/file-download.service';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
/**
 * 組合員の声検索画面 モジュール設定クラス
 *
 * @export KYMW1900Module
 * @class KYMW1900Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
  ],
  declarations: [
    KYMW1900Component,
  ],
  providers: [
    FileDownloadConfirmService,
    FileDownloadService,
  ],
})
export class KYMW1900Module {
}
